import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './hole.json';import texture from './hole.png';export default new Aseprite(texture, data);